<template>
  <div>
    <div class="d-flex">
      <h5 class="text-light flex-fill pt-2">Denunciar Tópico</h5>
      <button class="btn" @click="closeDenounceDialog">
        <h5 class="text-light">
          <i class="icon-x"></i>
        </h5>
      </button>
    </div>
    <div v-if="denounceStep == 3">
      <div class="text-justify mb-4">
        Obrigado! Sua denúncia foi enviada para nossa central. Se este conteúdo
        estiver violando nossos
        <router-link :to="{ name: 'terms' }" class="text-success">
          <strong>
            Termos de uso
          </strong>
        </router-link>
        ou
        <router-link :to="{ name: 'privacy' }" class="text-success">
          <strong>
            Política de Privacidade
          </strong> </router-link
        >, ele será removido.
      </div>
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-success px-5"
          @click="onDenounceSuccess"
        >
          Ok, entendi
        </button>
      </div>
    </div>
    <div v-else>
      <div v-if="denounceStep == 1">
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            id="radio-group-1"
            v-model="selected"
            stacked
            :options="options"
            :aria-describedby="ariaDescribedby"
            name="radio-options"
          ></b-form-radio-group>
        </b-form-group>
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="btn btn-outline-secondary px-5 mr-4"
            @click="closeDenounceDialog"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success px-5"
            @click="onNextDenounceStep"
          >
            Continuar
          </button>
        </div>
      </div>
      <div v-if="denounceStep == 2">
        <form-group
          v-model="denounceForm.form.text_details"
          id="text"
          textarea
          placeholder="Forneça mais detalhes."
          :errors="denounceForm.errors.text_details"
          required
        />
        <div class="text-justify mb-4">
          <small>
            O comentário e o usuário sinalizado serão analisados por nossa
            equipe para determinar se eles violaram os
            <router-link :to="{ name: 'terms' }" class="text-success">
              <strong>
                Termos de uso
              </strong>
            </router-link>
            e
            <router-link :to="{ name: 'privacy' }" class="text-success">
              <strong>
                Política de Privacidade
              </strong> </router-link
            >. A conta será penalizada e poderá ser encerrada se a mesma
            infração se repetir ou o correrem violações graves.notifications
          </small>
        </div>
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="btn btn-outline-secondary px-5 mr-4"
            @click="denounceStep = 1"
          >
            Voltar
          </button>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="loadingDenounce"
            @click="submitDenounce"
          >
            <loading :show="loadingDenounce">Denunciar</loading>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  name: "modal-denounce",
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      denounceStep: 1,
      denounceDialog: false,
      loadingDenounce: false,
      selected: "",
      ...formFields(["text"], { ...this.topic }),
      denounceForm: formFields(
        ["id_postforum", "text_reason", "text_details"],
        {
          id_postforum: this.topic.id
        }
      ),
      options: [
        {
          text: "Conteúdo comercial indesejado ou spam",
          value: "Conteúdo comercial indesejado ou spam"
        },
        {
          text: "Incitação ao ódio ou violência explícita",
          value: "Incitação ao ódio ou violência explícita"
        },
        { text: "Promove o terrorismo", value: "Promove o terrorismo" },
        { text: "Assédio ou bullying", value: "Assédio ou bullying" },
        { text: "Desinformação", value: "Desinformação" }
      ]
    };
  },
  methods: {
    closeDenounceDialog() {
      this.denounceDialog = false;
      this.denounceStep = 1;
      this.denounceForm = formFields(
        ["id_postforum", "text_reason", "text_details"],
        {
          id_postforum: this.topic.id
        }
      );
      this.$emit("close-modal");
    },
    onNextDenounceStep() {
      this.denounceForm.form.text_reason = this.selected;

      if (!this.denounceForm.form.text_reason.length) {
        this.$message.warning(
          "Antes de continuar, escolha a razão para sua denúncia."
        );
        return;
      }
      this.denounceStep = 2;
    },
    onDenounceSuccess() {
      this.closeDenounceDialog();
      this.$emit("refresh");
    },
    submitDenounce() {
      if (this.loadingDenounce) return;

      this.loadingDenounce = true;
      this.$store
        .dispatch("forum/report", {
          id: this.topic.id,
          data: this.denounceForm.form
        })
        .then(() => {
          this.denounceStep = 3;
        })
        .finally(() => {
          this.loadingDenounce = false;
        });
    }
  }
};
</script>
